import { Flex } from "@chakra-ui/react";
import React, { useState } from "react";
import { useLocation } from "react-router";
import styled from "styled-components";
import useEscape from "../../../hooks/useEscape";
import useKeyDown from "../../../hooks/useKeyDown";
import { useDevLogByTopic } from "../../../networking/dev-log.hooks";
import AppText from "../../Core/AppText/AppText";
import LogRow from "../LogRow/LogRow";

const LogsShortcut: React.FC = () => {
	const [show, setShow] = useState(false);

	const location = useLocation();

	const { topic, id } = parseTopicAndIdFromLocation(location.pathname);

	useKeyDown({
		onKeyDown: (e) => {
			if (e.ctrlKey && e.shiftKey && (e.key === "L" || e.key === "l") && topic && id) {
				setShow(true);
			}
		},
		disableIfAnyInputHasFocus: true,
	});

	useEscape({ onEscape: () => setShow(false), enabled: show });

	const { data: logRows } = useDevLogByTopic(
		{
			topic,
			id,
		},
		show
	);

	if (!show) {
		return null;
	}

	return (
		<Styles onClick={() => setShow(false)}>
			<div className="log-shortcut-window" onClick={(e) => e.stopPropagation()}>
				<Flex gap="1rem" direction="column">
					<AppText color="grayTextLight" size="s">
						Tryck "Esc" för att stänga fönstret
					</AppText>
					<Flex direction="column" overflowX={"auto"}>
						{logRows?.map((row) => (
							<LogRow key={row.transactionId} value={row} />
						))}
					</Flex>
				</Flex>
			</div>
		</Styles>
	);
};

export default LogsShortcut;

const Styles = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background-color: rgb(0, 0, 0, 0.15);
	z-index: 100;
	line-height: 1;

	.log-shortcut-window {
		position: absolute;
		padding: 1rem;
		left: calc(50vw - 600px + 50px);
		top: 100px;
		width: 1200px;
		min-height: 140px;
		max-height: calc(100vh - 200px);
		overflow-y: auto;
		background: white;
		border: 1px solid ${(props) => props.theme.colors.INPUT_BORDER_FOCUSED};
		border-radius: 15px;
		box-shadow: 0px 3px 30px rgba(0, 0, 0, 0.3);
	}
`;

/**
 * Figure out the topic and id from the location string.
 * This will map frontend lingo to backend lingo so somewhat fragile.
 * Make sure to update this in case frontend or backend routes changes.
 */
function parseTopicAndIdFromLocation(location: string) {
	// /jobs/aa1626f6-5607-4dd6-9781-fd28be6847f0/anything
	const parts = location.split("/");
	let topic = parts[1];
	let id = parts[2];

	if (topic === "jobs") {
		topic = "job";
	} else if (topic === "customers") {
		topic = "customer";
	} else if (topic === "consultants") {
		topic = "consultant-account";
	} else if (topic === "recruitment") {
		topic = "candidate-account";
	}

	return { topic, id };
}
